import Aimage from "../Aimage"

export default {
  name: 'Aimg',
  render() {
    const { ...attrs } = this.$attrs;
    return (<Aimage {...{ attrs }} />);
  }
}